module.exports = __webpack_public_path__ + "media/tulum/ruins-20736226.jpg";